import React from "react";
import { ActiveIntegrateCard } from "components";

export function ActiveCambiumIntegrations() {
  
  return (
    <ActiveIntegrateCard.Root
        name="Cambium Networks" 
        subtitle="Wi-Fi" 
        image_url="cambium-networks.png"
        option={{
            text: "Contact support",
            color: "red",
            onClick: () => {
            const supportEmail = "support@b-connect.co.uk";
            const subject = "Cambium Networks Support Request";
            const body = "Hello, I need help with Cambium Networks integration...";
            const mailtoLink = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoLink;
        },
      }}
    >
    </ActiveIntegrateCard.Root>
  );
}
